import React from 'react';
import { withStyles } from '@material-ui/core/styles';

function TableTop(props) {
  const { classes, children } = props;
  return (
    <div className={classes.root}>
      <span type="tableTitle" className={classes.title}>{children}</span>
    </div>
  );
}

const style = theme => ({
  root: {
    backgroundColor: theme.palette.primary.lighter,
    borderRadius: '8px 8px 0 0',
    height: '34px',
    minHeight: '34px',
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    marginLeft: '15px'
  }
});

export default withStyles(style)(TableTop);
